
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/[id]",
      function () {
        return require("private-next-pages/terms/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/[id]"])
      });
    }
  